function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.79079 0.709209C10.0697 0.988155 10.0697 1.44042 9.79079 1.71936L1.21936 10.2908C0.940416 10.5697 0.488155 10.5697 0.209209 10.2908C-0.0697365 10.0118 -0.0697365 9.55958 0.209209 9.28064L8.78064 0.709209C9.05958 0.430263 9.51184 0.430263 9.79079 0.709209Z",
  fill: "#8A93A6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.209209 0.709209C0.488155 0.430263 0.940416 0.430263 1.21936 0.709209L9.79079 9.28064C10.0697 9.55958 10.0697 10.0118 9.79079 10.2908C9.51184 10.5697 9.05958 10.5697 8.78064 10.2908L0.209209 1.71936C-0.0697365 1.44042 -0.0697365 0.988155 0.209209 0.709209Z",
  fill: "#8A93A6"
});

var SvgCrossSm = function SvgCrossSm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrossSm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cross-sm.5ea50b37.svg";
export { ForwardRef as ReactComponent };